export var FormNodeType;

(function (FormNodeType) {
  FormNodeType["ROOT"] = "root";
  FormNodeType["FIELD"] = "field";
  FormNodeType["GROUP"] = "group";
})(FormNodeType || (FormNodeType = {}));